<script>
import { validationMixin } from 'vuelidate'

import validationFormMixin from '@/mixins/validation.mixin'

export default {
  name: 'DurationInput',
  mixins: [validationMixin, validationFormMixin],
  props: {
    title: {
      type: String,
      required: false,
    },
    value: {
      type: String,
      required: false,
    },
    validationClass: {
      type: Object,
      required: false,
    },
    showDias: {
      type: Boolean,
      required: false,
      default: false,
    },
    showMinutos: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      form: {
        dias: 0,
        horas: 12,
        minutos: 0,
      },
      listOfMinutes: Array.from({ length: 60 }, (v, k) => k).reverse(),
      listOfHours: Array.from({ length: 24 }, (v, k) => k).reverse(),
    }
  },
  mounted() {
    if (this.value) {
      this.fromString(this.value)
    }
  },
  methods: {
    onChange() {
      this.$emit('input', this.toString())
    },
    toString() {
      let dias = this.form.dias
      let horas = this.form.horas
      let minutos = this.form.minutos

      if (!this.showDias) {
        dias = Math.floor(this.form.horas / 24)
        horas = Math.round(this.form.horas % 24)
      }

      if (!this.showMinutos) {
        minutos = 0
      }

      return `${dias}.${horas}:${minutos}`
    },
    fromString(duration) {
      const indexDias = duration.indexOf('.')

      if (indexDias !== -1) {
        this.form.dias = parseInt(duration.substring(0, indexDias))
        duration = duration.substring(indexDias + 1)
      } else {
        this.form.dias = 0
      }

      const duracao = duration.split(':')
      this.form.horas = parseInt(duracao[0])
      this.form.minutos = parseInt(duracao[1])

      if (!this.showDias) {
        this.form.horas = this.form.dias * 24 + this.form.horas
        this.form.dias = 0
      }

      if (!this.showMinutos) {
        this.form.minutos = 0
      }
    },
  },
}
</script>

<template>
  <div>
    <span v-if="title" class="md-subheading">{{ title }}</span>
    <div class="row">
      <div v-if="showDias" class="col">
        <md-field :class="validationClass">
          <label :for="`${_uid}dias`">Dias</label>
          <md-input
            :id="`${_uid}dias`"
            v-model="form.dias"
            type="number"
            name="dias"
            min="0"
            @change="onChange"
          />
        </md-field>
      </div>

      <div v-if="showDias" class="col">
        <md-field :class="validationClass">
          <label :for="`${_uid}horas`">Horas</label>
          <md-select
            :id="`${_uid}horas`"
            v-model="form.horas"
            name="movie"
            @md-selected="onChange"
          >
            <md-option v-for="i in listOfHours" :key="i" :value="i">
              {{ i }}
            </md-option>
          </md-select>
        </md-field>
      </div>

      <div v-if="!showDias" class="col">
        <md-field :class="validationClass">
          <label :for="`${_uid}horas`">Horas</label>
          <md-input
            :id="`${_uid}horas`"
            v-model="form.horas"
            type="number"
            name="horas"
            min="0"
            @change="onChange"
          />
        </md-field>
      </div>

      <div v-if="showMinutos" class="col">
        <md-field :class="validationClass">
          <label :for="`${_uid}minutos`">Minutos</label>
          <md-select
            :id="`${_uid}minutos`"
            v-model="form.minutos"
            name="movie"
            @md-selected="onChange"
          >
            <md-option v-for="i in listOfMinutes" :key="i" :value="i">
              {{ i }}
            </md-option>
          </md-select>
        </md-field>
      </div>
    </div>
    <slot />
  </div>
</template>

<style scoped lang="scss"></style>
